import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'mwp-thawte',
    templateUrl: './thawte.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ThawteComponent implements OnInit, OnDestroy {

    private nodeId: string  = 'mwp-thawte-script';

    constructor(
        private renderer2: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) { 
        let node = document.createElement('script');
        node.id = this.nodeId;
        node.type = 'text/javascript';
        node.text = `var __dcid = __dcid || [];
        __dcid.push({ "cid": "DigiCertClickID_j_hI2FlP", "tag": "j_hI2FlP" });
        (function () { 
            var cid = document.createElement("script"); 
            cid.async = true; 
            cid.src = "//seal.digicert.com/seals/cascade/seal.min.js"; 
            var s = document.getElementsByTagName("script"); 
            var ls = s[(s.length - 1)]; 
            ls.parentNode.insertBefore(cid, ls.nextSibling); 
            }()
        );`;
        this.renderer2.appendChild(this.document.body, node);
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        let node = this.document.getElementById(this.nodeId);
        if (node)
            node.remove();
        // this.renderer2.destroyNode(node);
    }
}